import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let user_id = useDataValue({
    context: 'global',
    path: 'user.id',
    viewPath: props.viewPath,
  })

  let board_id = useDataValue({
    context: 'board',
    path: 'id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      user_id,
      board_id,
    },
  }
}
